import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ApplicationStore, ApplicationStoreType } from '../../../../core/store/application.store';

@Component({
    selector: 'juyo-popup-base',
    styleUrl: 'popup-base.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="popup-backdrop" (click)="onClose()"></div>
        <div class="popup-card">
            @if (showHeader()) {
                <div class="popup-header">
                    <ng-content select="[slot=header]"></ng-content>
                    <button class="popup-close" type="button" aria-label="Close" (click)="onClose()">
                        <span class="material-symbols-outlined"> close </span>
                    </button>
                </div>
            } @else {
                <button class="popup-close popup-close--no-header" type="button" aria-label="Close" (click)="onClose()">
                    <span class="material-symbols-outlined"> close </span>
                </button>
            }
            <div class="popup-body">
                <ng-content select="[slot=body]"></ng-content>
            </div>
            @if (showFooter()) {
                <div class="popup-footer">
                    <ng-content select="[slot=footer]"></ng-content>
                </div>
            }
        </div>
    `,
})
export class PopupBaseComponent {
    public popupId = input.required<string>();
    public showHeader = input<boolean>(true);
    public showFooter = input<boolean>(true);

    private applicationStore: ApplicationStoreType = inject(ApplicationStore);

    protected onClose(): void {
        this.applicationStore.closePopup(this.popupId());
    }
}
